var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Profile__Page" }, [
    _c("div", { staticClass: "Profile__Page__Menu" }, [
      _c("h1", [_vm._v("הגדרות קורס")]),
      _c("ul", [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "general" } }, [
              _vm._v(" הגדרות כלליות "),
            ]),
          ],
          1
        ),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "navigation" } }, [
              _vm._v(" תפריט ניווט "),
            ]),
          ],
          1
        ),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "calendar" } }, [
              _vm._v(" לוח שנה לקורס "),
            ]),
          ],
          1
        ),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "AdminCourseRequests" } }, [
              _vm._v(" מרכז פניות "),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "Profile__Page__Content" },
      [_vm.ready ? _c("router-view") : _vm._e()],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }